export const MOVIE_SEARCH_API ='23d1b6c16ef4432a40ef5b34461a0048'

export const OPTIONS= {
    method: 'GET',
    headers: {
      accept: 'application/json',
      Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIyM2QxYjZjMTZlZjQ0MzJhNDBlZjViMzQ0NjFhMDA0OCIsInN1YiI6IjY2MmJjMTc0YzFmZmJkMDExZTZjMmZjMiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.oskMkKziBQv9AJdGdK_oByPoOqHa3hc1zKNu80sAeQA'
    }
  };

  export const NO_IMG ="https://th.bing.com/th/id/OIP.DZLWFqYqIG4l_yJaqOuJXgHaHa?w=183&h=183&c=7&r=0&o=5&dpr=1.3&pid=1.7";